import { MuzeumPage } from './../muzeum/muzeum';
import { Component } from '@angular/core';
import { NavController , NavParams,IonicPage } from 'ionic-angular';
import {DataProvider} from '../../providers/data/data';
import { ExhibitionPage } from '../../pages/exhibition/exhibition';
import { SpotPage } from '../../pages/spot/spot';
import { SpotsListPage } from '../../pages/spots-list/spots-list';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * Generated class for the ExhibitionListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  name: 'exhibitionlist',
  segment: 'exhibitionlist/:exhibitionlist'
})
@Component({
  selector: 'page-exhibition-list',
  templateUrl: 'exhibition-list.html',
})
export class ExhibitionListPage {


    lang; 
    showBack=true;
    muzeum;
    MuzeumData={
      name:'',
      discription:'',
      ExhibitionStyle:''
    };
    backGroundCove="";
  
    id;
    urlCode;
    exhibition;
    spots:any;
    oneExID:any;
    Exhibitions;
    loaderPage = false;
    loaderPageDisplayNone = false;
    oneExe = false;
    constructor(private sanitizer: DomSanitizer,public navCtrl: NavController, public navParams:NavParams, private _DataProvider:DataProvider) {
   
      this.lang = this._DataProvider.getLocalStorage('lang');
      this.muzeum = this._DataProvider.getLocalStorage('muzeum');
      this.oneExID = this._DataProvider.getLocalStorage('exhibitionID');

   
  
      this._DataProvider.navigationC.home = true;
      this._DataProvider.navigationC.more = false;
      this._DataProvider.navigationC.numType = false;
  
  
    }
    cssEX:any = '';
  
  
  
    currentPage
    
    ionViewDidEnter() {
      this._DataProvider.currentPage = 'exhibitionlist'


      this._DataProvider.showPad = false;
      this._DataProvider.menuShow = false;
      this._DataProvider.mapShow = false;
      this._DataProvider.NowLang= this.lang;
      this.muzeum = this._DataProvider.getLocalStorage('muzeum');
      // console.log(this.muzeum);
  
  if(this.muzeum){
      this._DataProvider.getMuzeumByurlCodeFB(this.muzeum).subscribe((res:any) => {
        console.log("res",res);
        console.log(res[0]);
        this._DataProvider.Muzeum = res[0];
       this._DataProvider.backGroundCove=res[0].background;
       this.backGroundCove=res[0].background;
  
  
        if(res[0].settings.css){
          this.cssEX = ` <style>`;
          this.cssEX += res[0].settings.css;
          this.cssEX += ` </style>`;
          this.cssEX = this.sanitizer.bypassSecurityTrustHtml(this.cssEX);
          console.log('CSS--------',this.cssEX);
      
        }
  
        this.MuzeumData = this._DataProvider.getMuzeumData(this.lang);
        console.log('FB - Muzeum._id', this._DataProvider.Muzeum);
        console.log('FB - this.lang', this.lang);
        
        this._DataProvider.getSpotsByExhibitionIDFB(this.oneExID)
        .subscribe(res2 => {
          var res:any=res2;
          if(res.length > 1){

            res = res.sort((a, b) => parseInt(a.code) - parseInt(b.code));
          }
          // res = res.sort((a, b) => { if (parseInt(a.code) < 0) {return -1; } if (parseInt(b.code) <0 ) {return 1;} return parseInt(b.code) - parseInt(a.code) });

          this.spots = res;
          this._DataProvider.spotsList = res;
          this.loaderPage = true;
          setTimeout(() => {
            this.loaderPageDisplayNone = true;
          }, 1300);
      console.log(this.spots);
   
            });
  
      console.log(this.Exhibitions);
      console.log(this.MuzeumData);
      console.log(this.muzeum);
      console.log(this.lang);
  
            });
          }
  
  
  
  
      // this._DataProvider.getMuzeumByurlCode(this.muzeum)
      // .subscribe(res => {
      //   console.log(res["theResult"][0]);
      //   this._DataProvider.Muzeum = res["theResult"][0];
  
      //   this.MuzeumData = this._DataProvider.getMuzeumData(this.lang);
  
      //   this._DataProvider.getExhibitionByLang(this._DataProvider.Muzeum._id,this.lang)
      //   .subscribe(res => {
      //     console.log(res["theResult"]);
      //     this.Exhibitions = res["theResult"];
      //     this._DataProvider.ExhibitionsService= res["theResult"];
      // console.log(this.Exhibitions);
      // console.log(this.MuzeumData);
      // console.log(this.muzeum);
      // console.log(this.lang);
  
      //       });
      //     });
  
  
  
      
   
  
  
  
          
  
      // Put here the code you want to execute
    }

    gotoSpot(item){
      console.log(item);
      this._DataProvider.selectedSpotExe = item.id;
      console.log(this._DataProvider.selectedSpotExe);
      console.log(this.muzeum);
      this._DataProvider.setLocalStorage('selectedSpotID', item.id);
      this.navCtrl.push(SpotPage, {
        muzeum:this.muzeum,
        id:this._DataProvider.selectedSpotExe,
        exhibition:item.ExhibitionsID,
  
      })
  
    }
  
    enterSpotsList(select){
      SpotsListPage
      this._DataProvider.selectedExebition = select;
      this._DataProvider.setLocalStorage('exhibitionID',select.id);
      this._DataProvider.setLocalStorage('spotType',select.spotType);
      this.navCtrl.push(SpotsListPage, {
        muzeum:this.muzeum,
      })
  
    }
  
    enterExhibitionGlobal(){
      console.log('this.Exhibitions[0]',this.Exhibitions[0]);
      console.log('this.muzeum',this.muzeum);
     this._DataProvider.selectedExebition = this.Exhibitions[0];
     this._DataProvider.setLocalStorage('exhibitionID',this.Exhibitions[0].id);
  
      this.navCtrl.push(ExhibitionPage, {
        muzeum:this.muzeum,
      })
    }
    
  
    goToCode(){
  
    
  
     this._DataProvider.selectedExebition = this.Exhibitions[0];
     this._DataProvider.setLocalStorage('exhibitionID',this.Exhibitions[0].id);
     this._DataProvider.setLocalStorage('spotType',this.Exhibitions[0].spotType);
  
  
      this.navCtrl.push(ExhibitionPage, {
        muzeum:this.muzeum,
      })
    }
    enterExhibition(select){
      console.log(select);
      this._DataProvider.selectedExebition = select;
      this._DataProvider.setLocalStorage('exhibitionID',select.id);
      this._DataProvider.setLocalStorage('spotType',select.spotType);
  
      this.navCtrl.push(ExhibitionPage, {
        muzeum:this.muzeum,
      })
  
    }
  
    goBack(){
      setTimeout(() => {
        this.navCtrl.setRoot(MuzeumPage, {
          muzeum: this.muzeum,
        })
      }, 200);
    }
  
    ulClass(){
      if(this.MuzeumData.ExhibitionStyle == 'option2'){
        return true;
      }else{
        return false;
      }
    }
  }
  




// WEBPACK FOOTER //
// ./src/pages/exhibition-list/exhibition-list.ts